<script setup>

</script>

<template>
  <div class="tl-footer">
    <div class="footer-content bg-image" style="background-image: url(/static/image/footer.jpg);">
      <div class="container">

        <div class="footer-middle">
          <div class="row">
            <div class="col-md-8 col-lg-4">
              <div class="footer-widget">
                <div class="footer-logo" style="display: flex; justify-content: center">
                  <img src="/static/picture/logo1.png" alt="Logo" class="img-fluid" style="width: 30%; height: 30%;">
                </div>
                <p>冬夏门窗公司始终秉承“信誉第一、客户至上”的企业宗旨，结合国内对家居环境要求，不断推陈出新。</p>
                <span class="phone-number"><a href="tel:+8613802623082"> <span class="mr-2 fa fa-phone"></span>+86 13802623082</a></span>
              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="footer-widget">

              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-8 col-lg-3">
              <div class="footer-widget">
                <h3>导航</h3>
                <ul class="global-list">
                  <li><a href="/about">关于我们</a></li>
                  <li><a href="/products">产品介绍</a></li>
                  <li><a href="/blogs">博客</a></li>
                  <li><a href="/contact">联系我们</a></li>
                </ul>
              </div><!-- /.footer-widget -->
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="footer-widget">
                <h3>产品 分类</h3>
                <ul class="global-list">
                  <li><a href="/products/?category_id_category=Aluminum Window">铝合金窗</a></li>
                  <li><a href="/products/?category_id_category=Aluminum Door">铝合金门</a></li>
                  <li><a href="/products/?category_id_category=Sunroom">阳光房</a></li>
                </ul>
              </div><!-- /.footer-widget -->
            </div>
          </div><!-- /.row -->
        </div><!-- /.footer-middle -->

        <div class="footer-bottom clearfix">
          <div class="d-flex justify-content-between">
            <div class="left-content">
              <span>Copyright &copy; 2025.Company name All rights reserved.</span>
            </div>
            <div class="right-content">
              <ul class="global-list d-flex">
                <li><a href="/contact">联系我们</a></li>
              </ul>
            </div>
          </div>
        </div><!-- /.footer-bottom -->
      </div><!-- /.container -->
    </div><!-- /.footer-content -->
  </div><!-- /.tl-footer -->
</template>

<style scoped lang="scss">

</style>